const categoryUserSitePublisherDevelopment = [
  {
    id: 6,
    name: "گروه بنری  روز مرد ۱۴۰۰ ",
    count_position: "5",
    start_date: "2022/11/04",
    end_date: "2022/11/15",
    count_day: "12",
    created_at: "2022/11/18 13:40:27",
    amount: 193665,
    sites: {
      251: {
        0: {
          title: "جایگاه های مستقل",
          price: 20500,
          positions: [
            {
              tag_html_id: "hilite-position-7",
              size: "300-600",
              count: "4",
              base_price: "50000",
              price: "12500",
            },
            {
              tag_html_id: "hilite-position-6",
              size: "300-250",
              count: "5",
              base_price: "40000",
              price: "8000",
            },
          ],
        },
        9: {
          title: "صفحات محصولات",
          price: 103333,
          positions: [
            {
              tag_html_id: "hilite-position-68",
              size: "180-600",
              count: "3",
              base_price: "70000",
              price: "23333",
            },
            {
              tag_html_id: "hilite-position-67",
              size: "970-250",
              count: "1",
              base_price: "70000",
              price: "70000",
            },
            {
              tag_html_id: "hilite-position-70",
              size: "720-300",
              count: "2",
              base_price: "20000",
              price: "10000",
            },
          ],
        },
        10: {
          title: "صفحات مطالب",
          price: 26500,
          positions: [
            {
              tag_html_id: "hilite-position-71",
              size: "970-90",
              count: "5",
              base_price: "30000",
              price: "6000",
            },
            {
              tag_html_id: "hilite-position-72",
              size: "120-600",
              count: "4",
              base_price: "50000",
              price: "12500",
            },
            {
              tag_html_id: "hilite-position-74",
              size: "180-600",
              count: "5",
              base_price: "40000",
              price: "8000",
            },
          ],
        },
        url: "https://barikell-test.ir",
      },
      254: {
        23: {
          title: "تماس با ما",
          price: 43332,
          positions: [
            {
              tag_html_id: "hilite-position-136",
              size: "970-90",
              count: "2",
              base_price: "20000",
              price: "10000",
            },
            {
              tag_html_id: "hilite-position-137",
              size: "970-250",
              count: "3",
              base_price: "80000",
              price: "26666",
            },
            {
              tag_html_id: "hilite-position-138",
              size: "120-600",
              count: "3",
              base_price: "20000",
              price: "6666",
            },
          ],
        },
        url: "https://sepehr-steel-test.ir",
      },
    },
  },
  {
    id: 5,
    name: "گروه بنری روز زن ۱۴۰۰",
    start_date: "2022/11/04",
    end_date: "2022/11/16",
    count_day: "13",
    created_at: "2022/10/25 13:40:27",
    amount: 57823,
    sites: {
      254: {
        23: {
          title: "تماس با ما",
          price: 43323,
          positions: [
            {
              tag_html_id: "hilite-position-137",
              size: "970-250",
              count: "3",
              base_price: "80000",
              price: "26666",
            },
            {
              tag_html_id: "hilite-position-138",
              size: "120-600",
              count: "3",
              base_price: "20000",
              price: "6666",
            },
            {
              tag_html_id: "hilite-position-136",
              size: "970-90",
              count: "2",
              base_price: "20000",
              price: "10000",
            },
          ],
        },
        25: {
          title: "صفحات مطالب",
          price: 14500,
          positions: [
            {
              tag_html_id: "hilite-position-147",
              size: "300-600",
              count: "5",
              base_price: "10000",
              price: "2000",
            },
            {
              tag_html_id: "hilite-position-148",
              size: "970-90",
              count: "4",
              base_price: "50000",
              price: "12500",
            },
          ],
        },
        url: "https://sepehr-steel-test.ir",
      },
    },
  },
  {
    id: 4,
    name: "گروه بنری عید فطر ۱۴۰۰	",
    start_date: "2022/02/14",
    end_date: "2022/02/17",
    count_day: "4",
    created_at: "2022/02/12 10:48:27",
    amount: 287500,
    sites: {
      250: {
        0: {
          title: "جایگاه های مستقل",
          price: 97500,
          positions: [
            {
              tag_html_id: "hilite-position-2",
              size: "180-600",
              count: "4",
              base_price: "20000",
              price: "5000",
            },
            {
              tag_html_id: "hilite-position-3",
              size: "970-90",
              count: "1",
              base_price: "50000",
              price: "50000",
            },
            {
              tag_html_id: "hilite-position-5",
              size: "720-300",
              count: "1",
              base_price: "40000",
              price: "40000",
            },
          ],
        },
        4: {
          title: "صفحات محصولات",
          price: 30000,
          positions: [
            {
              tag_html_id: "hilite-position-42",
              size: "970-90",
              count: "5",
              base_price: "50000",
              price: "10000",
            },
            {
              tag_html_id: "hilite-position-43",
              size: "300-600",
              count: "4",
              base_price: "40000",
              price: "10000",
            },
            {
              tag_html_id: "hilite-position-41",
              size: "970-90",
              count: "3",
              base_price: "30000",
              price: "10000",
            },
          ],
        },
        url: "https://batmatic-test.ir",
      },
      261: {
        0: {
          title: "جایگاه های مستقل",
          price: 125000,
          positions: [
            {
              tag_html_id: "hilite-position-151",
              size: "300-600",
              count: "2",
              base_price: "90000",
              price: "45000",
            },
            {
              tag_html_id: "hilite-position-152",
              size: "300-250",
              count: "1",
              base_price: "80000",
              price: "80000",
            },
          ],
        },
        26: {
          title: "صفحه تماس با ما",
          price: 20000,
          positions: [
            {
              tag_html_id: "hilite-position-156",
              size: "300-600",
              count: "3",
              base_price: "60000",
              price: "20000",
            },
          ],
        },
        27: {
          title: "صفحات مطالب",
          price: 15000,
          positions: [
            {
              tag_html_id: "hilite-position-157",
              size: "720-300",
              count: "4",
              base_price: "60000",
              price: "15000",
            },
          ],
        },
        url: "https://rubitools-test.ir",
      },
    },
  },
  {
    id: 3,
    name: "گروه بنری عید نوروز ۱۴۰۰",
    start_date: "2022/01/22",
    end_date: "2022/01/24",
    count_day: "3",
    created_at: "2022/01/20 19:39:23",
    amount: 310831,
    sites: {
      250: {
        2: {
          title: "درباره felotools",
          price: 46665,
          positions: [
            {
              tag_html_id: "hilite-position-31",
              size: "970-250",
              count: "3",
              base_price: "50000",
              price: "16666",
            },
            {
              tag_html_id: "hilite-position-32",
              size: "970-90",
              count: "3",
              base_price: "50000",
              price: "16666",
            },
            {
              tag_html_id: "hilite-position-34",
              size: "720-300",
              count: "3",
              base_price: "40000",
              price: "13333",
            },
          ],
        },
        5: {
          title: "صفحات مطالب",
          price: 66666,
          positions: [
            {
              tag_html_id: "hilite-position-46",
              size: "970-90",
              count: "3",
              base_price: "30000",
              price: "10000",
            },
            {
              tag_html_id: "hilite-position-47",
              size: "180-600",
              count: "3",
              base_price: "80000",
              price: "26666",
            },
            {
              tag_html_id: "hilite-position-48",
              size: "300-600",
              count: "2",
              base_price: "60000",
              price: "30000",
            },
          ],
        },
        url: "https://batmatic-test.ir",
      },
      251: {
        6: {
          title: "صفحه اصلی",
          price: 110000,
          positions: [
            {
              tag_html_id: "hilite-position-51",
              size: "300-250",
              count: "1",
              base_price: "100000",
              price: "100000",
            },
            {
              tag_html_id: "hilite-position-52",
              size: "300-600",
              count: "5",
              base_price: "50000",
              price: "10000",
            },
          ],
        },
        8: {
          title: "تماس با ما",
          price: 87500,
          positions: [
            {
              tag_html_id: "hilite-position-62",
              size: "970-250",
              count: "1",
              base_price: "60000",
              price: "60000",
            },
            {
              tag_html_id: "hilite-position-63",
              size: "970-250",
              count: "2",
              base_price: "10000",
              price: "5000",
            },
            {
              tag_html_id: "hilite-position-64",
              size: "970-250",
              count: "4",
              base_price: "90000",
              price: "22500",
            },
          ],
        },
        url: "https://barikell-test.ir",
      },
    },
  },
];

const categoryUserSitePublisherProduction = [
  {
    id: 3,
    name: "گروه بنری روز زن ۱۴۰۰",
    start_date: "2022/01/22",
    end_date: "2022/01/24",
    count_day: "3",
    created_at: "2022/01/20 19:39:23",
    amount: 67500,
    sites: {
      20: {
        0: {
          title: "جایگاه های مستقل",
          price: 3500,
          positions: [
            {
              tag_html_id: "hilite-position-331",
              size: "970-90",
              count: "3",
              base_price: "10500",
              price: "3500",
            },
          ],
        },
        84: {
          title: "صفحه اصلی",
          price: 7000,
          positions: [
            {
              tag_html_id: "hilite-position-308",
              size: "970-250",
              count: "3",
              base_price: "12000",
              price: "4000",
            },
            {
              tag_html_id: "hilite-position-310",
              size: "970-90",
              count: "3",
              base_price: "9000",
              price: "3000",
            },
          ],
        },
        85: {
          title: "تماس با ما",
          price: 2000,
          positions: [
            {
              tag_html_id: "hilite-position-311",
              size: "970-90",
              count: "2",
              base_price: "4000",
              price: "2000",
            },
          ],
        },
        url: "https://bestig.ir",
      },
      84: {
        587: {
          title: "صفحه اصلی",
          price: 14500,
          positions: [
            {
              tag_html_id: "hilite-position-1920",
              size: "970-90",
              count: "3",
              base_price: "19500",
              price: "6500",
            },
            {
              tag_html_id: "hilite-position-1919",
              size: "970-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
            {
              tag_html_id: "hilite-position-1918",
              size: "970-90",
              count: "3",
              base_price: "10500",
              price: "3500",
            },
          ],
        },
        588: {
          title: "محصولات",
          price: 9000,
          positions: [
            {
              tag_html_id: "hilite-position-1922",
              size: "300-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
            {
              tag_html_id: "hilite-position-1923",
              size: "300-600",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
          ],
        },
        589: {
          title: "درباره با ما",
          price: 3500,
          positions: [
            {
              tag_html_id: "hilite-position-1926",
              size: "970-90",
              count: "3",
              base_price: "4500",
              price: "1500",
            },
            {
              tag_html_id: "hilite-position-1927",
              size: "970-250",
              count: "3",
              base_price: "6000",
              price: "2000",
            },
          ],
        },
        url: "https://jobs-info.ir",
      },
      237: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: [
            {
              tag_html_id: "hilite-position-1321",
              size: "300-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
          ],
        },
        395: {
          title: "صفحه اصلی",
          price: 11000,
          positions: [
            {
              tag_html_id: "hilite-position-1323",
              size: "970-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
            {
              tag_html_id: "hilite-position-1324",
              size: "720-300",
              count: "3",
              base_price: "19500",
              price: "6500",
            },
          ],
        },
        398: {
          title: "تماس با ما",
          price: 3500,
          positions: [
            {
              tag_html_id: "hilite-position-1328",
              size: "970-250",
              count: "3",
              base_price: "6000",
              price: "2000",
            },
            {
              tag_html_id: "hilite-position-1327",
              size: "970-90",
              count: "3",
              base_price: "4500",
              price: "1500",
            },
          ],
        },
        399: {
          title: "صفحات محصولات",
          price: 9000,
          positions: [
            {
              tag_html_id: "hilite-position-1331",
              size: "300-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
            {
              tag_html_id: "hilite-position-1323",
              size: "970-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
          ],
        },
        url: "https://eimeni.ir",
      },
    },
  },
  {
    id: 2,
    name: "گروه بنری عید فطر ۱۴۰۰",
    start_date: "2021/05/12",
    end_date: "2021/05/16",
    count_day: "5",
    created_at: "2021/05/10 16:47:45",
    amount: 40500,
    sites: {
      1: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: [
            {
              tag_html_id: "hilite-position-1268",
              size: "300-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
          ],
        },
        379: {
          title: "صفحه اصلی",
          price: 8000,
          positions: [
            {
              tag_html_id: "hilite-position-1269",
              size: "970-90",
              count: "3",
              base_price: "10500",
              price: "3500",
            },
            {
              tag_html_id: "hilite-position-1270",
              size: "970-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
          ],
        },
        383: {
          title: "درباره با ما",
          price: 3500,
          positions: [
            {
              tag_html_id: "hilite-position-1274",
              size: "720-300",
              count: "3",
              base_price: "6000",
              price: "2000",
            },
            {
              tag_html_id: "hilite-position-1273",
              size: "970-90",
              count: "3",
              base_price: "4500",
              price: "1500",
            },
          ],
        },
        url: "https://monirlock.ir",
      },
      63: {
        91: {
          title: "صفحه اصلی",
          price: 11500,
          positions: [
            {
              tag_html_id: "hilite-position-375",
              size: "970-250",
              count: "3",
              base_price: "12000",
              price: "4000",
            },
            {
              tag_html_id: "hilite-position-376",
              size: "970-250",
              count: "3",
              base_price: "6000",
              price: "2000",
            },
            {
              tag_html_id: "hilite-position-374",
              size: "970-90",
              count: "2",
              base_price: "11000",
              price: "5500",
            },
          ],
        },
        92: {
          title: "درباره با ما",
          price: 2500,
          positions: [
            {
              tag_html_id: "hilite-position-372",
              size: "970-250",
              count: "3",
              base_price: "4500",
              price: "1500",
            },
            {
              tag_html_id: "hilite-position-371",
              size: "970-90",
              count: "3",
              base_price: "3000",
              price: "1000",
            },
          ],
        },
        url: "https://www.ezcurra.ir",
      },
      153: {
        1: {
          title: "صفحه اصلی",
          price: 5000,
          positions: [
            {
              tag_html_id: "hilite-position-2",
              size: "720-300",
              count: "3",
              base_price: "6000",
              price: "2000",
            },
            {
              tag_html_id: "hilite-position-7",
              size: "970-90",
              count: "3",
              base_price: "9000",
              price: "3000",
            },
          ],
        },
        6: {
          title: "تماس با ما",
          price: 1000,
          positions: [
            {
              tag_html_id: "hilite-position-337",
              size: "970-90",
              count: "3",
              base_price: "3000",
              price: "1000",
            },
          ],
        },
        8: {
          title: "درباره ما",
          price: 4500,
          positions: [
            {
              tag_html_id: "hilite-position-17",
              size: "970-90",
              count: "3",
              base_price: "3000",
              price: "1000",
            },
            {
              tag_html_id: "hilite-position-18",
              size: "720-300",
              count: "3",
              base_price: "6000",
              price: "2000",
            },
            {
              tag_html_id: "hilite-position-19",
              size: "970-250",
              count: "3",
              base_price: "4500",
              price: "1500",
            },
          ],
        },
        url: "https://sista.ir",
      },
    },
  },
  {
    id: 1,
    name: "گروه بنری عید نوروز ۱۴۰۰",
    start_date: "2021/03/19",
    end_date: "2021/04/09",
    count_day: "22",
    created_at: "2021/03/17 11:00:16",
    amount: 594500,
    sites: {
      84: {
        588: {
          title: "محصولات",
          price: 11500,
          positions: [
            {
              tag_html_id: "hilite-position-1922",
              size: "300-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
            {
              tag_html_id: "hilite-position-1923",
              size: "300-600",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
            {
              tag_html_id: "hilite-position-1925",
              size: "120-600",
              count: "3",
              base_price: "7500",
              price: "2500",
            },
          ],
        },
        url: "https://jobs-info.ir",
      },
      143: {
        517: {
          title: "صفحه اصلی",
          price: 270000,
          positions: [
            {
              tag_html_id: "hilite-position-1698",
              size: "300-250",
              count: "4",
              base_price: "200000",
              price: "50000",
            },
            {
              tag_html_id: "hilite-position-1699",
              size: "300-600",
              count: "4",
              base_price: "200000",
              price: "50000",
            },
            {
              tag_html_id: "hilite-position-1700",
              size: "970-90",
              count: "3",
              base_price: "210000",
              price: "70000",
            },
          ],
        },
        518: {
          title: "صفحات خبر",
          price: 300000,
          positions: [
            {
              tag_html_id: "hilite-position-1703",
              size: "300-250",
              count: "4",
              base_price: "400000",
              price: "100000",
            },
            {
              tag_html_id: "hilite-position-1704",
              size: "300-600",
              count: "3",
              base_price: "600000",
              price: "200000",
            },
          ],
        },
        url: "https://senfnews.com",
      },
      214: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: [
            {
              tag_html_id: "hilite-position-1054",
              size: "300-250",
              count: "3",
              base_price: "13500",
              price: "4500",
            },
          ],
        },
        307: {
          title: "صفحه اصلی",
          price: 6000,
          positions: [
            {
              tag_html_id: "hilite-position-1056",
              size: "970-250",
              count: "3",
              base_price: "12000",
              price: "4000",
            },
            {
              tag_html_id: "hilite-position-1057",
              size: "720-300",
              count: "3",
              base_price: "6000",
              price: "2000",
            },
          ],
        },
        310: {
          title: "تماس با ما",
          price: 2500,
          positions: [
            {
              tag_html_id: "hilite-position-1065",
              size: "970-250",
              count: "3",
              base_price: "4500",
              price: "1500",
            },
            {
              tag_html_id: "hilite-position-1064",
              size: "970-90",
              count: "3",
              base_price: "3000",
              price: "1000",
            },
          ],
        },
        url: "https://solga.ir",
      },
    },
  },
];

const getCategoryUserSitePublisher = () => {
  if (process.env.REACT_APP_STATE == "PRODUCTION") {
    return categoryUserSitePublisherProduction;
  }
  return categoryUserSitePublisherDevelopment;
};

export default getCategoryUserSitePublisher();
